module.exports = __webpack_public_path__ + "media/images/visio/tutorial-2-1b0b95edece97ec664e3799903e27881.jpg";